import { RoutesBuilder, generateIfPath } from './utils';


// lazy: () => import('@Plugin/theme').
export const buildWebsiteRoutes: RoutesBuilder = (instance) => [
	...generateIfPath({
		path: instance.route?.home,
		// lazy: () => import('@Template/Landing'),
	}),
]